import { render, staticRenderFns } from "./icon-delete-attribute.vue?vue&type=template&id=369e47d2"
import script from "./icon-delete-attribute.vue?vue&type=script&lang=js"
export * from "./icon-delete-attribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports